import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import ImgTask from '../../../Assets/frontendImages/CTA 3.svg'
import btnStyles from '../../UIs/PrimaryHero.module.css'; 

const HeroContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 60px 80px;
  background: var(--newBackgroundGrey);
  border-radius: 20px;
  max-width: 1400px;
  margin: 0 auto; 
  box-sizing: border-box;
  position: relative;

  @media (max-width: 992px) {
    flex-direction: column;
    padding: 50px 20px;
    gap: 2rem;
  }
`;

const HeroLeft = styled.div`
  max-width: 500px;

  @media (max-width: 1200px) {
    max-width: 400px;
  }

  @media (max-width: 992px) {
    max-width: 100%;
    text-align: center; 
  }
`;

const Heading = styled.h1`
  font-size: 36px;
  font-weight: 600;
  color: var(--font1);
  margin-bottom: 20px;
  line-height: 1.2;

  span {
    color: var(--brandColor);
  }

  @media (max-width: 992px) {
    font-size: 2rem;
  }

  @media (max-width: 576px) {
    font-size: 1.5rem;
  }
`;

const Description = styled.p`
  font-size: 16px;
  color: var(--font1);
  margin-bottom: 30px;
  line-height: 1.6;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  white-space: nowrap;
  display: inline-flex;       
  align-items: center;        
  justify-content: center;    
`;

const HeroRight = styled.div`
  border-radius: 20px;
`;

const HeroImage = styled.img`
  max-width: 100%;
`;

const FooterBar = styled.footer`
  background: var(--bgColorFrontend);
  color: var(--brandColor);
  text-align: center;
  padding: 20px 10px;
  font-size: 16px;
  margin-top: 5rem;

  @media (max-width: 576px) {
    margin-top: 3rem;
  }
`;

const Footer = () => {
  return (
    <>
        <HeroContainer data-aos="fade-up">
          <HeroLeft>
            <Heading>
              Everything You Need <br />
              in <span>One Place</span>
            </Heading>
            <Description>
              Create invoices, send contracts, track tasks, and manage clients — all from one affordable workspace.
            </Description>
            <StyledLink 
              to="/db/signup" 
              className={btnStyles.btn_begin}
            >
              Get Started for Free
            </StyledLink>
          </HeroLeft>
          <HeroRight>
            <HeroImage
              src={ImgTask}
              alt="Dashboard Preview"
            />
          </HeroRight>
        </HeroContainer>
      
      <FooterBar>
        © Zodot Software 2026
      </FooterBar>
    </>
  );
};

export default Footer;